<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div class="container-fluid">
        <span style="display: inline;">
          <div style="float: right;">
            <button
              class="btn btn-info mb-2 mr-2"
              @click.prevent="openAddHolidayModal"
            >
              <i class="fas fa-plus"></i>
              Public Holiday
              <!-- Lịch nghỉ lễ -->
            </button>
            <button class="btn btn-info mb-2" @click.prevent="openAddModal">
              <i class="fas fa-plus"></i>
              Register
              <!-- Đăng kí -->
            </button>
          </div>
          <b-row>
            <b-col cols="7">
              <b-form-select
                v-model="year"
                class="mb-2 mr-2"
                style="width: 20%"
                :options="optionsYear"
                value-field="value"
                text-field="text"
                @change="reQueryMonthData"
              />
              <b-form-select
                v-model="month"
                class="mb-2 mr-2"
                style="width: 20%"
                :options="optionsMonth"
                value-field="value"
                text-field="text"
                @change="reQueryMonthData"
              />
              &nbsp;
              <button
                class="btn btn-success mb-2 mr-2"
                @click.prevent="excelReport"
              >
                <i class="far fa-file-excel"></i>
                Export
                <!-- Xuất excel -->
              </button>
              <button
                class="btn btn-secondary mb-2 mr-2"
                style="float: right;"
                @click.prevent="toggleColumn"
              >
                <i v-if="is_column_visible" class="fas fa-arrow-left"></i>
                <i v-else class="fas fa-arrow-right"></i>
              </button>
              &nbsp;
              <template v-if="finalizelocked && salarylocked">
                <!-- tháng đã khóa lương và chốt -->
                <!-- khóa chấm công -->
                <template v-if="!is_all_department && islocked">
                  <i class="fas fa-lock" style="color:green"></i>
                </template>
                <!-- chưa khóa chấm công -->
                <template v-else-if="!is_all_department && !islocked">
                  <i class="fas fa-unlock-alt"></i>
                </template>
              </template>
              <template v-else-if="!finalizelocked">
                <!-- tháng chưa chốt -->
                <!-- tháng đã khóa lương -->
                <template v-if="!salarylocked">
                  <button
                    v-if="!is_all_department && !islocked"
                    class="btn btn-outline-success mb-2 mr-2"
                    type="button"
                    @click.prevent="changeLock"
                  >
                    <i class="fas fa-lock" style="color:green"></i>
                    Lock
                    <!-- Khóa -->
                  </button>
                  <template v-if="islocked">
                    <button
                      class="btn btn-outline-dark mb-2 mr-2"
                      type="button"
                      @click.prevent="changeLock"
                    >
                      <i class="fas fa-unlock-alt"></i>
                      Unlock
                      <!-- Mở khóa -->
                    </button>
                    <b style="color:red;">
                      LOCKED MONTH
                      <!-- THÁNG ĐÃ KHÓA -->
                    </b>
                  </template>
                </template>
                <!-- tháng đã khóa lương -->
                <template v-else-if="salarylocked">
                  <!-- khóa chấm công -->
                  <template v-if="!is_all_department && islocked">
                    <button
                      class="btn btn-outline-success mb-2 mr-2"
                      :disabled="true"
                      type="button"
                    >
                      <i class="fas fa-lock" style="color:green"></i>
                      Lock
                      <!-- Khóa -->
                    </button>
                  </template>
                  <!-- chưa khóa chấm công -->
                  <template v-else-if="!is_all_department && !islocked"
                    ><button
                      class="btn btn-outline-dark mb-2 mr-2"
                      :disabled="true"
                      type="button"
                    >
                      <i class="fas fa-unlock-alt"></i>
                      Lock
                      <!-- Khóa -->
                    </button>
                  </template>
                  <b style="color:red; margin-left: 8px;">
                    Salary is locked
                    <!-- ĐÃ KHÓA LƯƠNG -->
                  </b>
                </template>
              </template>
            </b-col>
            <b-col cols="5">
              <b-form-input
                v-model="query"
                placeholder="Filter by employee code, name"
                @keydown.enter.prevent="queryItem"
              ></b-form-input>
            </b-col>
          </b-row>
          &nbsp;
        </span>
      </div>
      <b-row> </b-row>
      <GSTC id="GSTC" :config="config" @state="onState" />
    </div>

    <!-- LEAVE MODAL -->
    <b-modal
      v-model="modalShow"
      size="xl"
      header-bg-variant="info"
      header-text-variant="light"
      @hide="closeModal"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          Create Time-off
          <!-- Tạo đơn nghỉ phép -->
        </div>
      </template>
      <b-form @submit.prevent="storeLeave" autocomplete="off">
        <b-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Name
              <!-- Tên nhân viên -->
            </label>
          </b-col>
          <b-col cols="9">
            <multiselect
              v-model="employee_selected"
              placeholder
              track-by="id"
              label="hovaten"
              selectedLabel="Đang chọn"
              select-label="Enter để chọn"
              deselectLabel="Enter để xóa"
              :searchable="true"
              :options="Employees"
              required
              :disabled="isUpdating"
            >
            </multiselect>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Time-off type
              <!-- Loại nghỉ phép -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-select
              v-model="form_leave.loainghiphep"
              :options="loainghipheps"
              value-field="id"
              text-field="pickListValue"
              :disabled="
                isUpdating &&
                  (form_leave.trangthaiduyet == 1 ||
                    form_leave.trangthaiduyet == 2)
              "
              required
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              From date
              <!-- Từ ngày -->
            </label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="form_leave.tungay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
              required
              :disabled="isUpdating"
            />
          </b-col>
          <b-col cols="1" />
          <b-col cols="2">
            <label class="mr-2">
              To date
              <!-- Tới ngày -->
            </label>
          </b-col>
          <b-col cols="3">
            <vue-datepicker-local
              style="width: 100%"
              v-model="form_leave.denngay"
              :local="local"
              clearable
              format="DD/MM/YYYY"
              required
              :disabled="isUpdating"
            />
          </b-col>
        </b-row>
        <b-row
          class="mb-4"
          v-if="form_leave.loainghiphep == this.$timeoff_type_statutoryleave"
        >
          <b-col id="reasons_tio_req_form" cols="2">
            <label class="mr-2">
              Note
              <!-- Lý do -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea
              v-model="form_leave.lydo"
              rows="3"
              max-rows="6"
              :disabled="isUpdating"
            />
          </b-col>
        </b-row>
        <b-row
          class="mb-4"
          v-if="form_leave.loainghiphep == this.$timeoff_type_workfromhome"
        >
          <b-col id="reasons_tio_req_form" cols="2">
            <label class="mr-2">
              Reason of WFH
              <!-- Lý do -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea
              v-model="form_leave.lydo"
              rows="3"
              max-rows="6"
              :disabled="isUpdating"
            />
          </b-col>
        </b-row>
        <b-row
          class="mb-4"
          v-if="form_leave.loainghiphep == this.$timeoff_type_workfromhome"
        >
          <b-col id="task_during_tio_req_form" cols="2">
            <label class="mr-2">
              Task during WFH
              <!-- Lý do -->
            </label>
          </b-col>
          <b-col cols="9">
            <b-form-textarea
              v-model="form_leave.taskduringwfh"
              rows="3"
              max-rows="6"
              :disabled="isUpdating"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div inline>
              <template v-if="isUpdating">
                <b-button
                  variant="info"
                  type="submit"
                  :disabled="disable_save_button"
                  v-if="!form_leave.trangthaiduyet"
                >
                  <i class="fas fa-save mr-2"></i>Save
                </b-button>
                <b-button
                  variant="danger"
                  :disabled="disable_save_button"
                  @click.prevent="deleteLeave"
                  style="float:right;"
                >
                  <i class="fas fa-trash mr-2"></i>
                  Cancel
                  <!-- Hủy -->
                </b-button>
                <b-button
                  class="mr-2"
                  variant="success"
                  @click.prevent="approveItem"
                  style="float:right;"
                  v-if="!form_leave.trangthaiduyet"
                >
                  <i class="fas fa-check-square mr-2"></i>Approve
                </b-button>
              </template>
              <template v-else>
                <b-button variant="info" type="submit" style="float:right;">
                  <i class="fas fa-save mr-2"></i>Save
                </b-button>
              </template>
              <template
                v-if="
                  form_leave.loainghiphep == this.$timeoff_type_workfromhome
                "
              >
                <b-button
                  variant="warning"
                  type="submit"
                  :disabled="disable_save_button"
                  @click.prevent="downloadWFHDailyReport()"
                  style="float:right; margin-right: 20px;"
                >
                  <i class="fas fa-download mr-2"></i>WFH Daily Report
                </b-button>
              </template>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF LEAVE MODAL -->
    <!-- HOLIDAY MODAL -->
    <b-modal
      v-model="holidayModalShow"
      size="l"
      header-bg-variant="info"
      header-text-variant="light"
      @hide="closeHolidayModal"
      hide-footer
    >
      <template v-slot:modal-title>
        <div>
          <!-- Thêm ngày lễ -->
          Add holidays
        </div>
      </template>
      <b-form @submit.prevent="storeHoliday" autocomplete="off">
        <b-row class="mb-2">
          <b-col cols="2">
            <label class="mr-2">
              Holiday:
              <!-- Lễ: -->
            </label>
          </b-col>
          <b-col cols="10">
            <b-form-input v-model="form_holiday.ten" required></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col cols="2">
            <label class="mr-2">
              Date:
              <!-- Ngày: -->
            </label>
          </b-col>
          <b-col cols="7">
            <vue-datepicker-local
              style="width: 100%"
              v-model="form_holiday.ngaynghile"
              :local="local"
              clearable
              format="DD/MM/YYYY"
              required
            />
          </b-col>
          <b-col cols="3">
            <b-button variant="info" type="submit" style="float:right;">
              <i class="fas fa-save mr-2"></i>
              Save
              <!-- Lưu -->
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-table
            bordered
            head-variant="dark"
            hover
            responsive
            striped
            small
            table-variant="light"
            :fields="holidayFields"
            :items="holidayItems"
          >
            <template v-slot:cell(action)="data">
              <b-link
                class="text-danger"
                href="#"
                @click.prevent="deleteHoliday(data)"
              >
                <i class="fas fa-trash"></i>
              </b-link>
            </template>
            <template v-slot:cell(ngaynghile)="data">
              {{ data.item.ngaynghile | moment("DD/MM/YYYY") }}
            </template>
          </b-table>
        </b-row>
      </b-form>
    </b-modal>
    <!-- END OF HOLIDAY MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import GSTC from "vue-gantt-schedule-timeline-calendar";
import ItemMovement from "gantt-schedule-timeline-calendar/dist/ItemMovement.plugin.js";
import Selection from "gantt-schedule-timeline-calendar/dist/Selection.plugin.js";
import WeekendHighlight from "gantt-schedule-timeline-calendar/dist/WeekendHighlight.plugin.js";
import VueDatepickerLocal from "vue-datepicker-local";
import "vue-datepicker-local/dist/vue-datepicker-local.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

let currently_selected = [];
let selection_plugin;
let SCREEN_HEIGHT_OFFSET = 275; //280 - 264 - 275

export default {
  name: "LeaveSchedule",
  components: {
    GSTC,
    VueDatepickerLocal,
    Multiselect,
  },
  props: {},
  data() {
    return {
      config: {
        height: window.screen.height - SCREEN_HEIGHT_OFFSET,
        list: {
          //toggle:{ display: true},
          toggle: { display: false },
          // Row Properties
          rows: {
            // "1": {
            //   id: "1",
            //   label: "M001",
            //   hovaten: "Nguyễn Quang Vũ",
            //   chucvu: "Chairman",
            //   khongluong: 23
            // },
          },
          // Column Definition
          columns: {
            isHTML: true,
            data: {
              stt: {
                id: "stt",
                data: "stt",
                width: 40,
                header: {
                  content: "No.",
                  // content: "STT",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 70,
                header: {
                  content: "Code",
                  // content: "MÃ NV",
                },
              },
              hovaten: {
                id: "hovaten",
                data: "hovaten",
                //data: '<div>your html here</div>',
                width: 180,
                //textAlign: "left",
                //isHTML: true,
                header: {
                  content: "Name",
                  // content: "Họ và tên",
                },
              },
              chucvu: {
                id: "chucvu",
                data: "chucvu",
                width: 100,
                header: {
                  content: "Position",
                  // content: "Chức vụ",
                },
              },
              tongngaycong: {
                id: "tongngaycong",
                data: "tongngaycong",
                width: 70,
                header: {
                  html: "Workday", //CT
                  // html: "Công thực tế", //CT
                },
              },
              nghiphep: {
                id: "nghiphep",
                data: "nghiphep",
                width: 90,
                textAlign: "center",
                header: {
                  html: `Paid Leave`, //"Nghỉ phép" //"P",
                },
              },
              khongluong: {
                id: "khongluong",
                data: "khongluong",
                width: 95,
                header: {
                  html: "Unpaid Leave", //'KL',
                  //html: "Nghỉ không lương", //'KL',
                },
              },
              statutoryleave: {
                id: "statutoryleave",
                data: "statutoryleave",
                width: 115,
                header: {
                  html: "Statutory Leave", //"SL"
                },
              },
              workfromhome: {
                id: "workfromhome",
                data: "workfromhome",
                width: 115,
                header: {
                  html: "Work from home", //"WFH"
                },
              },
              ngaycong: {
                id: "ngaycong",
                data: "ngaycong",
                width: 95,
                header: {
                  html: "Total Workday", //"C",
                  // html: "Tổng ngày công", //"C",
                },
              },
              // phepton: {
              //   id: "phepton",
              //   data: "phepton",
              //   width: 135,
              //   header: {
              //     html: "Unused Leave " + new Date().getFullYear(), //"T",
              //     // html: "Phép tồn " + new Date().getFullYear(), //"T",
              //   },
              // },
            },
          },
        },
        chart: {
          time: {
            // The timeline begins and ends.
            from: new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ).getTime(),
            to:
              new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1,
                1
              ).getTime() - 1,
            zoom: 10,
          },
          items: {
            "0": {
              // ANCHOR
              id: "0",
              rowId: "-1",
              label: "",
              time: {
                start: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  1
                ).getTime(),
                end: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  1
                ).getTime(),
              },
            },
          },
        },
        locale: {
          name: "zh",
          Now: "Now",
          weekdays: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
        },
        actions: {
          "chart-timeline-items-row-item": [this.addListenClick],
        },
        plugins: [
          WeekendHighlight({}),
          Selection({
            cell: false,
            items: false,
            rows: false,
            grid: false,
            rectStyle: { opacity: "1.0" },
            selecting(data, type) {
              currently_selected = [];
            },
            deselecting(data, type) {
              currently_selected.push(data);
            },
            getApi(api) {
              selection_plugin = api;
            },
          }),
        ],
      },

      holidayFields: [
        {
          key: "ten",
          label: "Holiday",
          // label: "Lễ",
        },
        {
          key: "ngaynghile",
          label: "Date",
          // label: "Ngày",
        },
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: { width: "25px !important", textAlign: "center" },
        },
      ],

      holidayItems: [],
      holidayColorItems: [],

      local: {
        monthsHead: "Tháng 1_Tháng 2_Tháng 3_Tháng 4_Tháng 5_Tháng 6_Tháng 7_Tháng 8_Tháng 9_Tháng 10_Tháng 11_Tháng 12".split(
          "_"
        ), // months of head
        months: "Th 1_Th 2_Th 3_Th 4_Th 5_Th 6_Th 7_Th 8_Th 9_Th 10_Th 11_Th 12".split(
          "_"
        ), // months of panel
        weeks: "CN_T2_T3_T4_T5_T6_T7".split("_"), // weeks,
      },

      form_leave: {
        id: 0,
        employeeid: 0,
        tungay: "",
        denngay: "",
        lydo: "",
        taskduringwfh: "",
        loainghiphep: null,
        trangthaiduyet: 0,
        songaynghi: 0,
      },

      form_holiday: {
        id: 0,
        ten: "",
        ngaynghile: "",
      },

      employee_selected: null,

      modal: {
        visible: false,
        title: "",
        data: {},
      },
      subs: [],
      state: null,
      month_offset: 0,
      employees: [],
      rows: [],
      items: [],
      leaveschedules: [],
      modalShow: false,
      holidayModalShow: false,
      loainghipheps: [],
      vitricongviecs: [],
      historyItems: [],

      isUpdating: false,
      islocked: false,
      salarylocked: false,
      finalizelocked: false,
      query: null,
      year: 0,
      month: 0,

      is_column_visible: true,
      disable_save_button: false,
      optionsMonth: [
        { value: 1, text: "January" },
        { value: 2, text: "February" },
        { value: 3, text: "March" },
        { value: 4, text: "April" },
        { value: 5, text: "May" },
        { value: 6, text: "June" },
        { value: 7, text: "July" },
        { value: 8, text: "August" },
        { value: 9, text: "September" },
        { value: 10, text: "October" },
        { value: 11, text: "November" },
        { value: 12, text: "December" },
      ],
    };
  },
  watch: {},
  computed: {
    Employees() {
      var emp_list = this.employees.slice();
      for (var emp of emp_list) {
        emp.hovaten = emp.manhanvien + " - " + emp.hovaten;
      }
      return emp_list;
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = 2020; i <= this_year; ++i) {
        result.push({ value: i, text: i });
      }
      if (new Date().getMonth() >= 11) {
        result.push({ value: this_year + 1, text: this_year + 1 });
      }
      return result;
    },
    is_all_department() {
      return this.$store.state.auth.departmentId == 0;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get(`/api/leaveschedule/employee`, { params: to.query }),
        axios.get("/api/picklist?q=loainghiphep|vitricongviec"),
        axios.get("/api/leaveschedule"),
        axios.get("/api/leaveschedule/holiday"),
        axios.get("/api/leaveschedule/holidayColor"),
        axios.get("/api/leaveschedule/lock"), // khóa chấm công
        axios.get("/api/salary/lock"), // khóa lương
        axios.get("/api/salary/finalizelock"), //chốt chấm công và lương
      ])
      .then(
        axios.spread(
          (
            employee,
            picklist,
            leaveschedule,
            holiday,
            holidaycolor,
            islocked,
            salarylocked,
            finalizelocked
          ) => {
            next((vm) =>
              vm.initData(
                employee.data,
                picklist.data,
                leaveschedule.data,
                holiday.data,
                holidaycolor.data,
                islocked.data,
                salarylocked.data,
                finalizelocked.data
              )
            );
          }
        )
      );
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get("/api/leaveschedule/employee", { params: to.query })
      .then((res) => {
        //this.employees = response.data.items;
        this.populateRow(res.data);
        this.populateSchedule(this.leaveschedules);
        // next();
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(
      employees,
      picklists,
      leaveschedules,
      holidays,
      holidayColors,
      islocked,
      salarylocked,
      finalizelocked
    ) {
      this.employees = employees;
      this.leaveschedules = leaveschedules;
      this.holidayItems = holidays;
      this.holidayColorItems = holidayColors;
      // this.loainghipheps = picklists.filter(
      //   (x) => x.pickListType == "loainghiphep"
      // );
      //       this.vitricongviecs = picklists.filter(
      //   (x) => x.pickListType == "vitricongviec"
      // );
      picklists.forEach((picklist, index) => {
        switch (picklist.pickListType) {
          case "loainghiphep":
            if (picklist.pickListValue == "Phép") {
              this.loainghipheps.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Paid leave",
              });
            } else if (picklist.pickListValue == "Nghỉ không lương") {
              this.loainghipheps.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Unpaid leave",
              });
            } else {
              this.loainghipheps.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: picklist.pickListValue,
              });
            }
            break;
          case "vitricongviec":
            this.vitricongviecs.unshift(picklist);
            break;
        }
      });
      this.islocked = islocked;
      this.salarylocked = salarylocked;
      this.finalizelocked = finalizelocked;
      this.year = new Date().getFullYear();
      this.month = parseInt(new Date().getMonth()) + 1;

      this.loainghipheps = this.$sort_order_list(this.loainghipheps);
      this.populateRow(this.employees);
      this.populateSchedule(this.leaveschedules);
    },
    //#region GSTC
    onState(state) {
      this.state = state;
    },

    //#region Populate
    populateRow(employees) {
      this.rows = [];
      for (let i = 0; i < employees.length; ++i) {
        const id = i;
        const stt = i + 1;
        const label = employees[i].manhanvien;
        const hovaten = employees[i].hovaten;
        const chucvu = employees[i].vitricongviec;
        const tongngaycong = employees[i].tongngaycong;
        const nghiphep = employees[i].nghiphep;
        const khongluong = employees[i].khongluong;
        const statutoryleave = employees[i].statutoryleave;
        const workfromhome = employees[i].workfromhome;
        const ngaycong = employees[i].ngaycong;
        // const phepton = employees[i].phepton;
        this.rows[id] = {
          id,
          stt,
          label,
          hovaten,
          chucvu,
          tongngaycong,
          nghiphep,
          khongluong,
          statutoryleave,
          workfromhome,
          ngaycong,
          // phepton,
        };
      }

      this.state.update("config.list.rows", this.rows);
    },

    populateSchedule(leaveschedules) {
      this.items = [];
      var old_manhanvien = -1;
      var rowid = -1;

      // MARK FOR HOLIDAYS
      {
        var max_schedule_id = 12345;
        var id_counter = 1000; // @CLARITY: Random padding. 1000 should be enough right ?!!??!?!
        for (var holiday of this.holidayItems) {
          for (var row of this.rows) {
            var new_holiday_item = {
              id: max_schedule_id + id_counter, // Hack to avoid duplicate id on the same schedule
              rowId: row.id,
              label: holiday.ten,
              time: {
                start: new Date(holiday.ngaynghile).getTime(),
                end:
                  new Date(holiday.ngaynghile).getTime() + 1000 * 60 * 60 * 24,
              },
              style: {
                textAlign: "center",
                background: "rgb(53 220 212 / 10%)", // 'rgb(220 53 69 / 10%)',//'red',
                color: "rgb(108 117 125 / 79%)",
                borderRadius: "0px",
                marginTop: "0px",
                height: "calc(var(--row-height))",
              },
            };

            id_counter++;
            this.items.push(new_holiday_item);
          }
        }
      }

      // MARK FOR HOLIDAY COLORS
      {
        var max_schedule_id2 = 22345;
        var id_counter2 = 2000; // @CLARITY: Random padding. 1000 should be enough right ?!!??!?!
        for (var holidayColor of this.holidayColorItems) {
          for (var row2 of this.rows) {
            var new_holiday_item2 = {
              id: max_schedule_id2 + id_counter2, // Hack to avoid duplicate id on the same schedule
              rowId: row2.id,
              label: "H", //holidayColor.ten,
              time: {
                start: new Date(holidayColor.ngaynghile).getTime(),
                end:
                  new Date(holidayColor.ngaynghile).getTime() +
                  1000 * 60 * 60 * 24,
              },
              style: {
                textAlign: "center",
                fontWeight: "bold",
                background: "rgb(197 224 250 / 10%)", // 'rgb(220 53 69 / 10%)',//'red',
                color: "rgb(108 117 125 / 79%)",
                borderRadius: "0px",
                marginTop: "0px",
                height: "calc(var(--row-height))",
              },
            };

            id_counter2++;
            this.items.push(new_holiday_item2);
          }
        }
      }

      // POPULATE SCHEDULE
      {
        for (var itr of leaveschedules) {
          if (itr.manhanvien != old_manhanvien) {
            var found_record = this.rows.find(function(el) {
              if (el.label === itr.manhanvien) return el;
            });

            if (typeof found_record == "undefined") continue;

            rowid = found_record.id;
            old_manhanvien = itr.manhanvien;
          }

          var new_item = {
            id: itr.id,
            rowId: rowid,
            label:
              this.findFirst(this.loainghipheps, itr.loainghiphep) +
              " (" +
              itr.songaynghi +
              ")",
            time: {
              start: new Date(itr.tungay).getTime(),
              end: new Date(itr.denngay).getTime(),
            },
            style: {
              textAlign: "center",
              background:
                itr.trangthaiduyet == 0
                  ? "blue"
                  : itr.trangthaiduyet == 1
                  ? "green"
                  : itr.trangthaiduyet == 2
                  ? "red"
                  : "white",
              borderRadius: "100px",
              marginTop: "5px",
            },
          };

          this.items.push(new_item);
        }
      }

      this.state.update("config.chart.items", this.items);
    },

    populateHoliday() {
      //this.state.update('config.chart.items', this.items);
    },

    //#endregion End Populate
    //#endregion End GSTC

    addListenClick(element, data) {
      const onClick = (e) => {
        e.preventDefault();
        this.openUpdateModal(data);
        return false;
      };
      element.addEventListener("click", onClick);
      return {
        update(element, newData) {
          data = newData;
        },
        destroy(element, data) {
          element.removeEventListener("click", onClick);
        },
      };
    },
    closeModal() {
      this.modalShow = false;
      this.employee_selected = null;
      this.form_leave.id = 0;
      this.form_leave.tungay = "";
      this.form_leave.denngay = "";
      this.form_leave.lydo = "";
      this.form_leave.taskduringwfh = "";
      this.form_leave.loainghiphep = null;
      this.isUpdating = false;
    },
    closeHolidayModal() {
      this.holidayModalShow = false;
    },
    reQueryMonthData() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year;
      query.month = this.month;
      query.deptid = this.$store.state.auth.departmentId;

      var from = new Date(this.year, this.month - 1, 1);
      var to = new Date(this.year, this.month, 1);
      this.state.update("config.chart.time", (time) => {
        time.from = from.getTime();
        time.to = to.getTime() - 1;
        return time;
      });

      axios
        .all([
          axios.get(`/api/leaveschedule/employee`, { params: query }),
          axios.get("/api/leaveschedule", { params: query }),
          axios.get("/api/leaveschedule/lock", { params: query }),
          axios.get("/api/salary/lock", { params: query }),
          axios.get("/api/salary/finalizelock", { params: query }),
          axios.get("/api/leaveschedule/holiday", { params: query }),
          axios.get("/api/leaveschedule/holidayColor", { params: query }),
        ])
        .then(
          axios.spread(
            (
              employees,
              leaveschedules,
              islocked,
              salarylocked,
              finalizelocked,
              holidays,
              holidayColors
            ) => {
              this.employees = employees.data;
              this.leaveschedules = leaveschedules.data;
              this.islocked = islocked.data;
              this.salarylocked = salarylocked.data;
              this.finalizelocked = finalizelocked.data;
              this.holidayItems = holidays.data;
              this.holidayColorItems = holidayColors.data;
              if (this.employees.length > 0) this.populateRow(this.employees);

              if (this.leaveschedules.length > 0)
                this.populateSchedule(this.leaveschedules);
              else {
                var anchor = {
                  id: "0",
                  rowId: "-1",
                  label: "",
                  time: { start: from, end: to },
                };

                this.items.push(anchor);
                this.state.update("config.chart.items", this.items);
              }
            }
          )
        );
    },
    openAddModal() {
      if (currently_selected.length > 0) {
        if (
          currently_selected[0].row.id !=
          currently_selected[currently_selected.length - 1].row.id
        ) {
          currently_selected = [];
          this.$toast.error("Please select only 1 person!", "Error", {
            timeout: 3000,
          });
          return;
        }
        var colon_index = currently_selected[0].id.indexOf(":") + 1;
        var from = currently_selected[0].id.substring(
          colon_index,
          colon_index + 10
        );
        var to = currently_selected[currently_selected.length - 1].id.substring(
          colon_index,
          colon_index + 10
        );

        this.form_leave.tungay = this.convert_date(from);
        this.form_leave.denngay = this.convert_date(to);
        this.form_leave.loainghiphep = this.$timeoff_type_paidleave;
        this.employee_selected = this.employees.find(
          (x) => x.manhanvien == currently_selected[0].row.label
        );

        currently_selected = [];
        selection_plugin.clearSelection(true);
      }

      this.modalShow = true;
    },
    openAddHolidayModal() {
      this.holidayModalShow = true;
    },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });

      return temp == null ? "" : temp.pickListValue;
    },

    openUpdateModal(data) {
      this.form_leave.id = parseInt(data.item.id);

      // To check if this is a holiday
      var found = this.leaveschedules.find((x) => x.id == data.item.id);
      if (typeof found == "undefined") return;

      axios.get(`/api/leaveschedule/${data.item.id}`).then((res) => {
        //if (this.leaveSchdules.includes()) return;
        this.form_leave.tungay = res.data.tungay;
        this.form_leave.denngay = res.data.denngay;
        this.form_leave.lydo = res.data.lydo;
        this.form_leave.taskduringwfh = res.data.taskduringwfh;
        this.form_leave.loainghiphep = res.data.loainghiphep;
        this.form_leave.trangthaiduyet = res.data.trangthaiduyet;
        this.form_leave.songaynghi = res.data.songaynghi;
        this.employee_selected = this.employees.find(
          (x) => x.employeeid == res.data.employeeid
        );
        this.modalShow = true;
        this.isUpdating = true;
      });
    },

    storeLeave() {
      this.disable_save_button = true;

      if (this.employee_selected == null) {
        this.$toast.error("Please select employee name!", "Error", {
          timeout: 3000,
        });
        return;
      }
      if (this.form_leave.tungay > this.form_leave.denngay) {
        this.$toast.error("The selected time period is not valid!", "Error", {
          timeout: 3000,
        });
        return;
      }

      this.form_leave.employeeid = this.employee_selected.employeeid;
      if (this.isUpdating) {
        this.updateLeave();
        return;
      }

      axios
        .post("/api/leaveschedule", this.form_leave)
        .then((res) => {
          this.$toast.success("Create susscessully!", "Success", {
            timeout: 2000,
          });
          this.addToCalendar(res.data);
          this.leaveschedules.push(res.data);
          // @TEMPORARY (maybe ????): Approve after create
          this.form_leave.id = res.data.id;
          this.approveItem();
          //this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {
          this.disable_save_button = false;
        });
    },

    updateLeave() {
      this.disable_save_button = true;

      axios
        .put("/api/leaveschedule", this.form_leave)
        .then((res) => {
          this.$toast.success("Update successfully!", "Success", {
            timeout: 2000,
          });
          this.items.find((x) => x.id == res.data.id).label = this.findFirst(
            this.loainghipheps,
            res.data.loainghiphep
          );
          this.state.update("config.chart.items", this.items);
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {
          this.disable_save_button = false;
        });
    },

    deleteLeave() {
      this.disable_save_button = true;

      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/leaveschedule/${this.form_leave.id}`)
                .then((res) => {
                  if (this.form_leave.trangthaiduyet != 0) {
                    var manhanvien = this.employees.find(
                      (x) => x.employeeid == res.data.empLeave.employeeid
                    ).manhanvien;
                    var row = this.rows.find(function(el) {
                      if (el.label == manhanvien) return el;
                    });

                    row.tongngaycong += res.data.empLeave.songaynghi;

                    switch (this.form_leave.loainghiphep) {
                      case this.$timeoff_type_paidleave:
                        row.nghiphep -= this.form_leave.songaynghi;
                        // row.phepton += this.form_leave.songaynghi;
                        break;
                      case this.$timeoff_type_unpaidleave:
                        row.khongluong -= this.form_leave.songaynghi;
                        row.ngaycong += this.form_leave.songaynghi;
                        break;
                      case this.$timeoff_type_workfromhome:
                        row.workfromhome -= this.form_leave.songaynghi;
                        break;
                      case this.$timeoff_type_statutoryleave:
                        row.statutoryleave -= this.form_leave.songaynghi;
                        break;
                    }

                    // if (
                    //   this.form_leave.loainghiphep ==
                    //   this.$timeoff_type_paidleave
                    // ) {
                    //   row.nghiphep -= this.form_leave.songaynghi;
                    //   // row.phepton += this.form_leave.songaynghi;
                    // }
                    // if (
                    //   this.form_leave.loainghiphep ==
                    //   this.$timeoff_type_unpaidleave
                    // ) {
                    //   row.khongluong -= this.form_leave.songaynghi;
                    //   row.ngaycong += this.form_leave.songaynghi;
                    // }
                    // if (
                    //   this.form_leave.loainghiphep ==
                    //   this.$timeoff_type_workfromhome
                    // ) {
                    //   row.workfromhome -= this.form_leave.songaynghi;
                    // }
                    // if (
                    //   this.form_leave.loainghiphep ==
                    //   this.$timeoff_type_statutoryleave
                    // ) {
                    //   row.statutoryleave -= this.form_leave.songaynghi;
                    // }
                  }

                  //#region Send mail when cancel Time-off
                  const email_form = res.data.emailArr;
                  axios
                    .post("/api/timeoffrequest/sendmail", email_form)
                    .then((res) => {
                      //   "Time-off Request has been successfully emailed!",
                      this.is_sent_email_timeoff = this.sent_timeoff_stt.SENT;
                    })
                    .catch((err) => {
                      this.res_message = err.response.data;
                      this.is_sent_email_timeoff = this.sent_timeoff_stt.SEND_ERROR;
                    })
                    .finally(() => {
                      this.disable_save_button = false;
                    });
                  //#endregion

                  this.$toast.success("Cancel successfully", "Success", {
                    timeout: 2000,
                  });
                  var del_index_leave = this.leaveschedules.indexOf(
                    this.leaveschedules.find(
                      (x) => x.id == res.data.empLeave.id
                    )
                  );
                  this.leaveschedules.splice(del_index_leave, 1);

                  var del_index = this.items.indexOf(
                    this.items.find((x) => x.id == res.data.empLeave.id)
                  );
                  this.items.splice(del_index, 1);
                  this.state.update("config.chart.items", this.items);
                  this.closeModal();
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                })
                .finally(() => {
                  this.disable_save_button = false;
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },

    storeHoliday() {
      axios
        .post("/api/leaveschedule/holiday", this.form_holiday)
        .then((res) => {
          this.holidayItems.push(res.data);
          this.form_holiday.ten = "";
          this.form_holiday.ngaynghile = "";
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    deleteHoliday(data) {
      this.$toast.question("Do you really want to delete?", "Warning", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Yes</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/leaveschedule/holiday/${data.item.id}`)
                .then((res) => {
                  this.holidayItems.splice(data.index, 1);
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Error", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>No</button>",
            function(instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
    date_different(first, second) {
      var result = 0;

      result = (second - first) / 86400000 + 1;

      if (result < 0) return 0;
      return result;
    },
    toMilisecond(days) {
      return days * 24 * 60 * 60 * 1000;
    },
    addToCalendar(data) {
      var manhanvien = this.employees.find(function(el) {
        if (el.employeeid == data.employeeid) return el;
      }).manhanvien;
      var rowid = this.rows.find(function(el) {
        if (el.label == manhanvien) return el;
      }).id;

      var new_item = {
        id: data.id,
        rowId: rowid,
        label:
          this.findFirst(this.loainghipheps, data.loainghiphep) +
          " (" +
          data.songaynghi +
          ")",
        time: {
          start: new Date(data.tungay).getTime(),
          end: new Date(data.denngay).getTime(),
        },
        style: {
          textAlign: "center",
          background: "blue",
        },
      };
      this.items.push(new_item);
      this.state.update("config.chart.items", this.items);
    },
    approveItem() {
      axios
        .put(
          `/api/leaveschedule/${this.form_leave.id}/${this.$timeoff_status_approved}`
        )
        .then((res) => {
          this.$toast.success("Approve successfully", "Success", {
            timeout: 2000,
          });

          const itemIndex = this.leaveschedules.findIndex(
            (x) => x.id === res.data.id
          );
          this.leaveschedules[itemIndex] = JSON.parse(JSON.stringify(res.data));
          const temp = JSON.parse(JSON.stringify(this.leaveschedules));
          this.leaveschedules = JSON.parse(JSON.stringify(temp));

          var row = this.rows.find((x) => x.label == res.data.manhanvien);
          row.tongngaycong -= res.data.songaynghi;

          switch (res.data.loainghiphep) {
            case this.$timeoff_type_paidleave:
              row.nghiphep += res.data.songaynghi;
              // row.phepton -= res.data.songaynghi;
              break;
            case this.$timeoff_type_unpaidleave:
              row.khongluong += res.data.songaynghi;
              row.ngaycong -= res.data.songaynghi;
              break;
            case this.$timeoff_type_workfromhome:
              row.workfromhome += res.data.songaynghi;
              break;
            case this.$timeoff_type_statutoryleave:
              row.statutoryleave += res.data.songaynghi;
              break;
          }

          // if (res.data.loainghiphep == this.$timeoff_type_paidleave) {
          //   row.nghiphep += res.data.songaynghi;
          //   // row.phepton -= res.data.songaynghi;
          // }
          // if (res.data.loainghiphep == this.$timeoff_type_unpaidleave) {
          //   row.khongluong += res.data.songaynghi;
          //   row.ngaycong -= res.data.songaynghi;
          // }
          // if (res.data.loainghiphep == this.$timeoff_type_workfromhome) {
          //   row.workfromhome += res.data.songaynghi;
          // }

          this.$toast.success("Approve successfully", "Success", {
            timeout: 2000,
          });
          this.items.find((x) => x.id == res.data.id).style.background =
            "green";
          this.state.update("config.chart.items", this.items);
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },

    disapproveItem() {
      axios
        .put(
          `/api/leaveschedule/${this.form_leave.id}/${this.$timeoff_status_declined}`
        )
        .then((res) => {
          if (this.form_leave.trangthaiduyet != 0) {
            var manhanvien = this.employees.find(
              (x) => x.employeeid == res.data.employeeid
            ).manhanvien;
            var row = this.rows.find(function(el) {
              if (el.label == manhanvien) return el;
            });

            row.tongngaycong += res.data.songaynghi;

            switch (res.data.loainghiphep) {
              case this.$timeoff_type_paidleave:
                row.nghiphep -= this.form_leave.songaynghi;
                // row.phepton += this.form_leave.songaynghi;
                break;
              case this.$timeoff_type_unpaidleave:
                row.khongluong -= this.form_leave.songaynghi;
                row.ngaycong += this.form_leave.songaynghi;
                break;
              case this.$timeoff_type_workfromhome:
                row.workfromhome -= res.data.songaynghi;
                break;
              case this.$timeoff_type_statutoryleave:
                row.statutoryleave -= res.data.songaynghi;
                break;
            }

            if (this.form_leave.loainghiphep == this.$timeoff_type_paidleave) {
              row.nghiphep -= this.form_leave.songaynghi;
              // row.phepton += this.form_leave.songaynghi;
            }
            if (
              this.form_leave.loainghiphep == this.$timeoff_type_unpaidleave
            ) {
              row.khongluong -= this.form_leave.songaynghi;
              row.ngaycong += this.form_leave.songaynghi;
            }
          }

          this.$toast.success("Decline successfully", "Success", {
            timeout: 2000,
          });
          this.items.find((x) => x.id == res.data.id).style.background = "red";
          this.state.update("config.chart.items", this.items);
          this.closeModal();
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      this.item = null;
      this.$router.push({ query: query });
    },
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year;
      query.month = this.month;
      axios({
        method: "get",
        url: `/api/leaveschedule/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
    },
    changeLock() {
      axios
        .post(
          "/api/leaveschedule/lock?islocked=" +
            this.islocked +
            "&year=" +
            this.year +
            "&month=" +
            this.month +
            "&deptid=" +
            this.$store.state.auth.departmentId
        )
        .then((res) => {
          this.islocked = res.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        });
    },
    convert_date(date) {
      var date_split = date.split("-");
      var result = date_split[2] + "/" + date_split[1] + "/" + date_split[0];
      return this.$convert_string_date(result);
    },
    toggleColumn() {
      var columns = document.querySelectorAll(
        ".gantt-schedule-timeline-calendar__list-column"
      );
      var colapse = "width: 0px; --with:0px";
      if (this.is_column_visible) {
        columns[4].style.cssText = colapse;
        columns[5].style.cssText = colapse;
        columns[6].style.cssText = colapse;
        columns[7].style.cssText = colapse;
        columns[8].style.cssText = colapse;
      } else {
        columns[4].style.cssText = "width: 90px; --with: 90px";
        columns[5].style.cssText = "width: 80px; --with: 80px";
        columns[6].style.cssText = "width: 120px; --with: 120px";
        columns[7].style.cssText = "width: 110px; --with: 110px";
        columns[8].style.cssText = "width: 100px; --with: 100px";
      }

      this.is_column_visible = !this.is_column_visible;
    },
    downloadWFHDailyReport() {
      this.disable_save_button = true;
      axios({
        method: "get",
        url: `/api/timeoffrequest/downloadwfhdailyreport`,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .replaceAll('"', "") // file name có chứa khoảng trắng nên khi gửi tên file từ API sẽ có dấu ""
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {})
        .finally(() => {
          this.disable_save_button = false;
        });
    },
  },
  beforeDestroy() {
    this.subs.forEach((unsub) => unsub());
  },
};
</script>
<style>
.wrapper .gantt-elastic__grid-line-time {
  display: none;
}

.gantt-schedule-timeline-calendar__chart-timeline-grid-row-block--weekend {
  background-color: rgb(220 53 69 / 10%);
}

.gantt-schedule-timeline-calendar__list-column-header {
  background: rgb(12 104 180);
  color: #ffffff;
  font-size: 12.5px;
}

.gantt-schedule-timeline-calendar__chart-calendar {
  background: rgb(12 104 180);
  color: #ffffff;
}

.gantt-schedule-timeline-calendar__chart-calendar-dates {
  background: rgb(12 104 180);
  color: #ffffff;
}

.gantt-schedule-timeline-calendar__list-column-header-content {
  text-align: center;
}

.gantt-schedule-timeline-calendar__list-column-row-content {
  text-align: center;
}
</style>
